import { Card, CardBody, Table } from "reactstrap";
import { InvoiceButtons } from "../common/InvoiceButtons";
import InvoiceAddSection from "./InvoiceAddSection";
import InvoiceAmountSection from "./InvoiceAmountSection";
import InvoiceHead from "./InvoiceHead";
import InvoiceTable from "./InvoiceTable";
import { ECommerce, Invoice } from "../../../../../constants";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

// This component displays the invoice 3, including invoice header, add section, table, amount section, and buttons.
const Invoice3Container = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Invoice} parent={ECommerce} />
      <div className="invoice-3">
        <Card>
          <CardBody>
            <Table borderless>
              <tbody>
                <InvoiceHead />
                <InvoiceAddSection />
                <InvoiceTable />
                <InvoiceAmountSection />
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
      <InvoiceButtons />
    </>
  );
};

export default Invoice3Container;
